module.exports = __webpack_public_path__ + "img/17.067bb906.png";